var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart_panel_title"},[_c('div',{staticClass:"bar"},_vm._l((_vm.bar),function(item,index){return _c('div',{key:index,staticClass:"block",style:({ color: item.color, flex: item.value ? item.value : 0})},[(item.value !== 0)?_c('div',{staticClass:"text"},[_vm._v(_vm._s(item.unit))]):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }